export default __webpack_public_path__ + "static/media/goonj_logo_2.02fac8c6.svg";